import React, { useEffect, useState } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import Navbar from './Navbar';
import Footer from './Footer';
import './InvitationLetter.css';
import IIScLogo from '../assets/LogoIISc.png';
import SignatureImage from '../assets/sign.png';

const API_BASE_URL = "https://api.rescons.in";

const InvitationLetter = () => {
  const [form, setForm] = useState({
    name: '',
    address: '',
    passportNumber: '',
    passportExpiry: '',
    country: '',
    nationality: '',
    dob: ''
  });
  const [role, setRole] = useState('speaker'); // default role
  const [loading, setLoading] = useState(true);
  const [abstractTitle, setAbstractTitle] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const uid = sessionStorage.getItem('uid');

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (role === 'speaker') {
          // Fetch saved invitation details
          const res = await axios.get(`${API_BASE_URL}/api/invitation-request/${uid}`);
          if (res.data) setForm(res.data);

          // Fetch abstract title only for speakers
          const abs = await axios.get(`${API_BASE_URL}/api/invitation-abstract-title/${uid}`);
          setAbstractTitle(abs.data.title || '');
        }
      } catch (err) {
        // It's ok if no data exists yet
      } finally {
        setLoading(false);
      }
    };
    if (uid) fetchData();
  }, [uid, role]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!form.name || !form.address || !form.passportNumber || !form.passportExpiry || !form.country || !form.nationality || !form.dob) {
      setError('Please fill all fields.');
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/invitation-request`, { ...form, uid, role });
      setSuccess('Details saved! Generating invitation letter...');
      setTimeout(() => handleDownloadPDF(), 1000);
    } catch (err) {
      setError('Failed to save details.');
    }
  };

  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF();

  //   const today = new Date();
  //   const day = String(today.getDate()).padStart(2, '0');
  //   const month = String(today.getMonth() + 1).padStart(2, '0');
  //   const year = today.getFullYear();
  //   const dateStr = `${day}-${month}-${year}`;

  //   const logoWidth = 28;
  //   const logoHeight = 28;
  //   const logoX = 20;
  //   const logoY = 20;
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const headerLines = [
  //     'DEPARTMENT OF MATERIALS ENGINEERING',
  //     'INDIAN INSTITUTE OF SCIENCE',
  //     'BANGALORE - 560012 INDIA'
  //   ];
  //   const subHeader = 'A centre for Advanced study Supported by the University Grants Commission.';
  //   const lineHeight = 7;
  //   const textBlockHeight = headerLines.length * lineHeight;
  //   const textStartY = logoY + (logoHeight / 2) - (textBlockHeight / 2);
  //   const textX = pageWidth / 2;

  //   const img = new window.Image();
  //   img.src = IIScLogo;
  //   img.onload = () => {
  //     doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
  //     doc.setFont('times', 'normal');
  //     doc.setFontSize(12);
  //     doc.text(headerLines[0], textX, textStartY, { align: 'center' });
  //     doc.text(headerLines[1], textX, textStartY + lineHeight, { align: 'center' });
  //     doc.text(headerLines[2], textX, textStartY + 2 * lineHeight, { align: 'center' });

  //     const subHeaderY = Math.max(logoY + logoHeight, textStartY + 3 * lineHeight) + 7;
  //     doc.setFontSize(10);
  //     doc.text(subHeader, pageWidth / 2, subHeaderY, { align: 'center' });

  //     let y = subHeaderY + 7;
  //     doc.setLineWidth(0.5);
  //     doc.line(20, y, 190, y); y += 7;
  //     doc.setFontSize(12);
  //     doc.text(`Date: ${dateStr}`, 20, y); y += 14;
  //     doc.text('To,', 20, y); y += 7;

  //     doc.text(`Name: ${form.name}`, 20, y); y += 7;
  //     doc.text(`Address: ${form.address}`, 20, y); y += 7;
  //     doc.text(`Country: ${form.country}`, 20, y); y += 7;
  //     doc.text(`Nationality: ${form.nationality}`, 20, y); y += 7;
  //     doc.text(`Passport Number: ${form.passportNumber}`, 20, y); y += 7;
  //     doc.text(`Passport Expiry: ${form.passportExpiry}`, 20, y); y += 7;
  //     doc.text(`Date of Birth: ${form.dob}`, 20, y); y += 10;

  //     doc.setFont('times', 'bold');
  //     doc.text(
  //       'Ref: Participation in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS-V).',
  //       20, y, { maxWidth: 170 }
  //     ); 
  //     y += 15;

  //     doc.setFont('times', 'normal');
  //     doc.text(`Dear ${form.name}`, 20, y); 
  //     y += 7;

  //     if (role === 'speaker') {
  //       const marginX = 20;
  //       const maxWidth = 170;
  //       let currentY = y;
  //       const intro = 'On behalf of organization committee, it is our pleasure to invite you to participate and deliver a talk ';
  //       const title = `"${abstractTitle}"`;
  //       const after = ' in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS - V) to be held at Indian Institute of Science, Bangalore, India, during 9 to 12 December, 2025.';

  //       const chunks = [
  //         { text: intro, style: 'normal' },
  //         { text: title, style: 'bold' },
  //         { text: after, style: 'normal' }
  //       ];

  //       let words = [];
  //       chunks.forEach(chunk => {
  //         chunk.text.split(' ').forEach((word, idx, arr) => {
  //           words.push({ word: word + (idx < arr.length - 1 ? ' ' : ''), style: chunk.style });
  //         });
  //       });

  //       let line = '';
  //       let lineStyles = [];
  //       words.forEach(({ word, style }) => {
  //         const testLine = line + word;
  //         doc.setFont('times', style);
  //         const testWidth = doc.getTextWidth(testLine);

  //         if (testWidth > maxWidth && line.length > 0) {
  //           let x = marginX;
  //           lineStyles.forEach(({ text, style }) => {
  //             doc.setFont('times', style);
  //             doc.text(text, x, currentY, { baseline: 'top' });
  //             x += doc.getTextWidth(text);
  //           });
  //           currentY += 7;
  //           line = word;
  //           lineStyles = [{ text: word, style }];
  //         } else {
  //           line += word;
  //           if (lineStyles.length > 0 && lineStyles[lineStyles.length - 1].style === style) {
  //             lineStyles[lineStyles.length - 1].text += word;
  //           } else {
  //             lineStyles.push({ text: word, style });
  //           }
  //         }
  //       });

  //       if (line.length > 0) {
  //         let x = marginX;
  //         lineStyles.forEach(({ text, style }) => {
  //           doc.setFont('times', style);
  //           doc.text(text, x, currentY, { baseline: 'top' });
  //           x += doc.getTextWidth(text);
  //         });
  //         currentY += 7;
  //       }
  //       currentY += 4;
  //       y = currentY;
  //     } else {
  //       const text = 'On behalf of organization committee, it is our pleasure to invite you to attend and participate in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS - V) to be held at Indian Institute of Science, Bangalore, India, during 9 to 12 December, 2025.';
  //       doc.text(text, 20, y, { maxWidth: 170 });
  //       y += 20;
  //     }

  //     doc.text('Please attach this letter with your visa application and submit it to your nearest Indian Embassy/Consulate in your country. For any clarifications, please e-mail us at stis.mte@iisc.ac.in.', 20, y, { maxWidth: 170 });
  //     y += 14;
  //     doc.text('We look forward to seeing you in Bengaluru.', 20, y); 
  //     y += 7;

  //     doc.text('With best regards', 20, y);
  //     y += 6;

  //     doc.text('Yours Sincerely,', 20, y);
  //     y += 6;

  //     const signatureImg = new window.Image();
  //     signatureImg.src = SignatureImage;
  //     signatureImg.onload = () => {
  //       const signatureWidth = 40;
  //       const signatureHeight = 20;
  //       doc.addImage(signatureImg, 'PNG', 20, y, signatureWidth, signatureHeight);
  //       y += signatureHeight;

  //       doc.text('Prof. Govind S. Gupta', 20, y);
  //       y += 6;
  //       doc.text('Convenor – STIS 2025', 20, y);

  //       doc.setFontSize(10);
  //       doc.line(20, 285, 190, 285);
  //       doc.text('Telephone: +91-080-22933240', 25, 292);
  //       doc.text('Mobile: +91-9945121973', 90, 292);

  //       const emailText = 'Email: govindg@iisc.ac.in';
  //       const emailX = 155;
  //       const emailY = 292;
  //       doc.setTextColor(0, 123, 255);
  //       doc.text(emailText, emailX, emailY);
  //       doc.setTextColor(0, 0, 0);

  //       const emailWidth = doc.getTextWidth(emailText);
  //       doc.link(emailX, emailY - 3, emailWidth, 5, { url: 'mailto:govindg@iisc.ac.in' });

  //       doc.save(`STISV2025_Invitation_${form.name.replace(/\s+/g, '_')}.pdf`);
  //     };
  //   };
  // };

  const handleDownloadPDF = () => {
  const doc = new jsPDF();

  // Date
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  const dateStr = `${day}-${month}-${year}`;

  // Constants
  const logoWidth = 28;
  const logoHeight = 28;
  const logoX = 20;
  const logoY = 20;
  const pageWidth = doc.internal.pageSize.getWidth();

  const headerLines = [
    "DEPARTMENT OF MATERIALS ENGINEERING",
    "INDIAN INSTITUTE OF SCIENCE",
    "BENGALURU - 560012 INDIA",
  ];
  const subHeader =
    "A centre for Advanced study Supported by the University Grants Commission.";

  const lineHeight = 7;
  const lineGap = 7; // standard gap between lines
  const sectionGap = 14; // extra gap between sections

  const textBlockHeight = headerLines.length * lineHeight;
  const textStartY = logoY + logoHeight / 2 - textBlockHeight / 2;
  const textX = pageWidth / 2;

  // Add Logo
  const img = new window.Image();
  img.src = IIScLogo;
  img.onload = () => {
    doc.addImage(img, "JPEG", logoX, logoY, logoWidth, logoHeight);

    // Header
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.text(headerLines[0], textX, textStartY, { align: "center" });
    doc.text(headerLines[1], textX, textStartY + lineHeight, {
      align: "center",
    });
    doc.text(headerLines[2], textX, textStartY + 2 * lineHeight, {
      align: "center",
    });

    // Subheader
    const subHeaderY =
      Math.max(logoY + logoHeight, textStartY + 3 * lineHeight) + lineGap;
    doc.setFontSize(10);
    doc.text(subHeader, pageWidth / 2, subHeaderY, { align: "center" });

    // Start body
    let y = subHeaderY + lineGap;
    doc.setLineWidth(0.5);
    doc.line(20, y, 190, y);
    y += lineGap;

    doc.setFontSize(12);
    doc.text(`Date: ${dateStr}`, 20, y);
    y += sectionGap;

    doc.text("To,", 20, y);
    y += lineGap;

    doc.text(`Name: ${form.name}`, 20, y);
    y += lineGap;

    doc.text(`Address: ${form.address}`, 20, y);
    y += lineGap;

    doc.text(`Country: ${form.country}`, 20, y);
    y += lineGap;

    doc.text(`Nationality: ${form.nationality}`, 20, y);
    y += lineGap;

    doc.text(`Passport Number: ${form.passportNumber}`, 20, y);
    y += lineGap;

    doc.text(`Passport Expiry: ${form.passportExpiry}`, 20, y);
    y += lineGap;

    doc.text(`Date of Birth: ${form.dob}`, 20, y);
    y += sectionGap;

    // Reference
    doc.setFont("times", "bold");
    doc.text(
      "Ref: Participation in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS-V).",
      20,
      y,
      { maxWidth: 170 }
    );
    y += sectionGap;

    // Salutation
    doc.setFont("times", "normal");
    doc.text(`Dear ${form.name}`, 20, y);
    y += lineGap;

    // Role-based content
    if (role === "speaker") {
      const marginX = 20;
      const maxWidth = 170;

      // Inline renderer: continues on same line and wraps when width exceeded
      let cursorX = marginX;
      let cursorY = y;
      const rightEdge = marginX + maxWidth;

      const writeInline = (text, style) => {
        if (!text) return;
        // split into tokens preserving spaces
        const tokens = text.match(/\S+\s*/g) || [];
        tokens.forEach(tok => {
          doc.setFont("times", style);
          const w = doc.getTextWidth(tok);
          if (cursorX + w > rightEdge && cursorX > marginX) {
            // wrap to next line
            cursorX = marginX;
            cursorY += lineGap;
          }
          doc.text(tok, cursorX, cursorY);
          cursorX += w;
        });
      };

      const intro =
        "On behalf of organization committee, it is our pleasure to invite you to participate and deliver a talk ";
      const title = `"${abstractTitle}"`;
      const after =
        " in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS - V) to be held at the Indian Institute of Science, Bengaluru, India, during 9 to 12 December, 2025.";

      // Write intro (normal), then title (bold) continuing the same line, then after (normal)
      writeInline(intro, "normal");
      writeInline(title, "bold");
      writeInline(after, "normal");

      // move y to next line after the paragraph + add one line gap
      y = cursorY + lineGap * 2;
    } else {
      const text =
        "On behalf of organization committee, it is our pleasure to invite you to attend and participate in the 5th International Conference on the Science & Technology of Ironmaking and Steelmaking (STIS - V) to be held at the Indian Institute of Science, Bengaluru, India, during 9 to 12 December, 2025.";
      doc.text(text, 20, y, { maxWidth: 170 });
      y += sectionGap * 1.5;
    }

    // Closing text
    doc.text(
      "Please attach this letter with your visa application and submit it to your nearest Indian Embassy/Consulate in your country. For any clarifications, please e-mail us at stis.mte@iisc.ac.in.",
      20,
      y,
      { maxWidth: 170 }
    );
    y += sectionGap;

    doc.text("We look forward to seeing you in Bengaluru.", 20, y);
    y += lineGap;

    doc.text("With best regards", 20, y);
    y += lineGap;

    doc.text("Yours Sincerely,", 20, y);
    y += 4; // reduced gap before signature

    // Signature
    const signatureImg = new window.Image();
    signatureImg.src = SignatureImage;
    signatureImg.onload = () => {
      const signatureWidth = 40;
      const signatureHeight = 20;
      doc.addImage(signatureImg, "PNG", 20, y, signatureWidth, signatureHeight);
      y += signatureHeight; // no extra lineGap here

      doc.text("Prof. Govind S. Gupta", 20, y);
      y += 5; // slightly smaller gap
      doc.text("Convenor – STIS 2025", 20, y);

      // Footer contact info
      doc.setFontSize(10);
      doc.line(20, 285, 190, 285);
      doc.text("Telephone: +91-080-22933240", 25, 292);
      doc.text("Mobile: +91-9945121973", 90, 292);

      const emailText = "Email: govindg@iisc.ac.in";
      const emailX = 155;
      const emailY = 292;
      doc.setTextColor(0, 123, 255);
      doc.text(emailText, emailX, emailY);
      doc.setTextColor(0, 0, 0);

      const emailWidth = doc.getTextWidth(emailText);
      doc.link(emailX, emailY - 3, emailWidth, 5, {
        url: "mailto:govindg@iisc.ac.in",
      });

      // Save file
      doc.save(`STISV2025_Invitation_${form.name.replace(/\s+/g, "_")}.pdf`);
    };
  };
};



  return (
    <>
      <Navbar />
      <div className="invitation-container">
        <h2>Get Visa Invitation Letter</h2>

        {/* Role Selection */}
        <div className="role-select" style={{ marginBottom: '20px' }}>
          <label style={{ marginRight: '20px' }}>
            <input
              type="radio"
              name="role"
              value="speaker"
              checked={role === 'speaker'}
              onChange={() => setRole('speaker')}
            /> Speaker / Participant / Student
          </label>
          <label>
            <input
              type="radio"
              name="role"
              value="accompanying"
              checked={role === 'accompanying'}
              onChange={() => setRole('accompanying')}
            /> Accompanying Person / Co-author
          </label>
        </div>

        {loading ? <p>Loading...</p> : (
          <form className="invitation-form" onSubmit={handleSubmit}>
            <label>Name:</label>
            <input name="name" value={form.name} onChange={handleChange} placeholder='As mentioned in the passport' required />
            <label>Address:</label>
            <textarea name="address" value={form.address} onChange={handleChange} placeholder='As mentioned in the passport' required />
            <label>Passport Number:</label>
            <input name="passportNumber" value={form.passportNumber} onChange={handleChange} required />
            <label>Passport Expiry:</label>
            <input name="passportExpiry" value={form.passportExpiry} onChange={handleChange} required placeholder="DD/MM/YYYY" />
            <label>Country:</label>
            <input name="country" value={form.country} onChange={handleChange} required />
            <label>Nationality:</label>
            <input name="nationality" value={form.nationality} onChange={handleChange} required />
            <label>Date of Birth:</label>
            <input name="dob" value={form.dob} onChange={handleChange} required placeholder="DD/MM/YYYY" />
            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}
            <button type="submit">Save & Download Invitation Letter</button>

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
              <h4 style={{ marginBottom: '10px', color: '#333' }}>For any clarifications, please contact:</h4>
              <p style={{ margin: '5px 0' }}>
                <strong>Email:</strong> <a href="mailto:stis.mte@iisc.ac.in" style={{ color: '#007bff', textDecoration: 'none' }}>stis.mte@iisc.ac.in</a>
              </p>
              <p style={{ margin: '5px 0' }}>
                <strong>Mobile:</strong> +919945121973
              </p>
              <p style={{ margin: '5px 0' }}>
                <strong>Telephone:</strong> +91-080-22933240
              </p>
            </div>
          </form>
        )}
      </div>
      <Footer />
    </>
  );
};

export default InvitationLetter;
